"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var Content = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  list-style: none;\n\n  & * {\n    cursor: ", ";\n    opacity: ", ";\n  }\n"], ["\n  cursor: ", ";\n  list-style: none;\n\n  & * {\n    cursor: ", ";\n    opacity: ", ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return disabled ? 'default !important' : 'pointer !important';
}, function (_a) {
    var disabled = _a.disabled;
    return disabled ? 'default' : 'pointer';
}, function (_a) {
    var disabled = _a.disabled;
    return disabled ? '.5' : '1';
});
var AXSTab = function (_a) {
    var active = _a.active, disabled = _a.disabled, handleMenuClick = _a.handleMenuClick, children = _a.children, className = _a.className, props = __rest(_a, ["active", "disabled", "handleMenuClick", "children", "className"]);
    var classes = [
        'c-axs-tab',
        'c-axs-menu__tab',
        { 'c-axs-tab--active': active },
        className
    ];
    return (React.createElement(Content, { onClick: function (e) { return !disabled ? handleMenuClick(e, props) : null; }, className: classnames_1.default(classes), active: active, disabled: disabled, role: "menuitem" },
        React.createElement("span", null, children)));
};
/** @component */
exports.default = AXSTab;
var templateObject_1;
//# sourceMappingURL=index.js.map